module.exports = __webpack_public_path__ + "b9e6be95123b145eaa1f74e9e9f13e1d.png";